import React from 'react';

const TicketScan = ({ inviteeData }) => {
  return (
    <div>
      {inviteeData?.name ? (
        <div className='flex flex-col gap-4 justify-center items-center h-screen w-screen text-primary p-10'>
          <div className='text-red-500'>
            {inviteeData?.scanStatus === 1 ? `Ticket has already been scanned by ${inviteeData.scannedBy} at ${inviteeData.scanTime}` : "Ticket scanned successfully"}
          </div>
          <div className=''>Invitee Name: {inviteeData?.name}</div>
          <div className=''>
            {inviteeData?.partnerName && `Partner Name: ${inviteeData.partnerName}`}
          </div>
          <div className=''>
            {inviteeData?.maxPlusOnes > 0 && `Maximum Plus Ones: ${inviteeData.maxPlusOnes}`}
          </div>
          <div className=''>Adults Table: {inviteeData?.adultsTable}</div>
          <div className=''>
            {inviteeData?.plusTable > 0 && `Plusones Table: ${inviteeData.plusTable}`}
          </div>
        </div>
      ) : (
        <div>Loading invitee...</div>
      )}
    </div>
  );
};

export default TicketScan;
